export default "__VITE_ASSET__AgWJqQYh__"